import './App.css'
import React from 'react'
import axios from 'axios';
import Recorder from './components/recorder/Recorder'
import 'antd/dist/antd.css';
import { Layout, Form, Input, Button, InputNumber, Radio, Switch, Select, Row, Col, Space, message } from 'antd';
const { Header, Footer, Content } = Layout;
const { Option } = Select

const listText = {
  text1: <span>Aujourd'hui,<br />c’est l’anniversaire de Mona. <br />La petite sorcière <br />a invité ses amis <br />à venir faire la fête chez elle. <br />Paco est déjà là.<br />Il aide Mona <br />à décorer l’appartement. <br />Charlotte, Samir et Garance <br />ne vont plus tarder à arriver.</span>,
  text2: <span>D’abord, Gabriel croit que l’araignée géante<br />qui le poursuit dans son rêve<br />a finalement réussi à le capturer.<br />Il se débat dans une espèce de toile, de voile…<br />Il ouvre les yeux : Brésil !<br />Le voile autour du lit, <br />c’est pour que les moustiques <br />ne le confondent pas<br />avec un sandwich pendant la nuit.</span>,
  text3: <span>A peine assis derrière son bureau couleur crème, <br />il entend qu’on frappe à la porte.<br />    - Entrez! dit-il surpris.<br />Un petit homme apparaît. <br />Il porte un costume avec une cravate ocre.<br />Ses cheveux bouclés forment un tas sur son crâne.<br />Comme il est petit et rond de plus,<br />le détective a l’impression<br />d’accueillir un crapaud avec une choucroute.</span>,
  text4: <span>Au beau milieu de la nuit,<br />Julia est réveillée par un petit bruit.<br />Elle reste un moment immobile<br />dans son lit<br />à tendre l’oreille<br />pour essayer de le localiser,<br />mais le silence est vite revenu,<br />elle n’entend plus que<br />la respiration régulière de sa soeur<br />au-dessus d’elle.<br />Elle se lève<br />et va sur la pointe des pieds<br />jusqu’au balcon<br />pour jeter un oeil dans le jardin.<br /><br />Mais qu’est-ce que…?<br /><br />Son coeur se met à cogner<br />dans sa poitrine.<br />Une forme blanche fantomatique<br />se déplace silencieusement<br />dans le jardin.<br />On dirait qu’elle glisse<br />au-dessus du sol.<br />Et elle n’a pas de tête !<br />Son corps se termine en pointe,<br />comme les fantômes<br />dans les bandes dessinées.<br /><br />Ça ne peut pas être vrai !<br />Je rêve !<br />Je suis en train de dormir et je rêve !<br />se dit Julia.<br /><br />Elle se pince fort pour se réveiller<br />et pousse un petit cri de douleur.<br />Le fantôme, lui,<br />continue à évoluer lentement.<br />À la place de son visage<br />il n’y a qu’un trou noir.<br />Non, elle ne rêve pas !<br /><br />Julia sent son coeur cogner si fort<br />qu’il devrait réveiller les autres.<br />Elle inspire profondément<br />et se prépare à hurler<br />de toutes ses forces<br />lorsqu’elle voit la forme blanche<br />s’installer sur la balancelle.<br /><br />Est-il possible<br />que les fantômes s’assoient<br />sur des balancelles ?<br />C’est peut-être un être humain ?<br />Et dans ce cas, ce serait qui ?<br />L’idée qu’un étranger<br />se promène dans le jardin<br />tout de blanc vêtu<br />lui paraît aussi effrayante<br />que si c’était un fantôme !<br /><br />Les nuages se déchirent dans le ciel<br />et la lune éclaire la forme blanche<br />qui lève soudain la tête.<br /><br />Julia retient son souffle.<br />Elle reconnaît ce visage !<br />C’est Frida !<br />C’est sa tante<br />qui est assise sur la balancelle<br />dans sa robe de chambre blanche,<br />la tête cachée sous la capuche.<br />L’illusion<br />qu’elle flottait au-dessus du sol<br />venait de ses chaussures sombres.<br /><br />Qu’est-ce qu’elle fait dehors<br />au beau milieu de la nuit ?<br />Julia regarde sa montre.<br />Deux heures trente !<br />Elle n’arrive pas à dormir,<br />elle non plus ?<br /><br />On dirait qu’elle fait le guet,<br />se dit soudain Julia.<br />Mais pourquoi ?<br /></span>,
  text5: <span>Au beau milieu de la nuit, Julia est réveillée par un petit bruit. Elle reste un moment immobile dans son lit à tendre l’oreille pour essayer de le localiser, mais le silence est vite revenu, elle n’entend plus que la respiration régulière de sa soeur au-dessus d’elle. Elle se lève et va sur la pointe des pieds jusqu’au balcon pour jeter un oeil dans le jardin.<br /><br />Mais qu’est-ce que…?<br /><br />Son coeur se met à cogner dans sa poitrine. Une forme blanche fantomatique se déplace silencieusement dans le jardin. On dirait qu’elle glisse au-dessus du sol. Et elle n’a pas de tête ! Son corps se termine en pointe, comme les fantômes dans les bandes dessinées.<br /><br />Ça ne peut pas être vrai ! Je rêve ! Je suis en train de dormir et je rêve ! se dit Julia.<br /><br />Elle se pince fort pour se réveiller et pousse un petit cri de douleur. Le fantôme, lui, continue à évoluer lentement. À la place de son visage il n’y a qu’un trou noir. Non, elle ne rêve pas !<br /><br />Julia sent son coeur cogner si fort qu’il devrait réveiller les autres. Elle inspire profondément et se prépare à hurler de toutes ses forces lorsqu’elle voit la forme blanche s’installer sur la balancelle.<br /><br />Est-il possible que les fantômes s’assoient sur des balancelles ? C’est peut-être un être humain ? Et dans ce cas, ce serait qui ? L’idée qu’un étranger se promène dans le jardin tout de blanc vêtu lui paraît aussi effrayante que si c’était un fantôme !<br /><br />Les nuages se déchirent dans le ciel et la lune éclaire la forme blanche qui lève soudain la tête.<br /><br />Julia retient son souffle. Elle reconnaît ce visage ! C’est Frida ! C’est sa tante qui est assise sur la balancelle dans sa robe de chambre blanche, la tête cachée sous la capuche. L’illusion qu’elle flottait au-dessus du sol venait de ses chaussures sombres.<br /><br />Qu’est-ce qu’elle fait dehors au beau milieu de la nuit ? Julia regarde sa montre. Deux heures trente ! Elle n’arrive pas à dormir, elle non plus ?<br /><br />On dirait qu’elle fait le guet, se dit soudain Julia. Mais pourquoi ?</span>,
  text6: <span>Tonton en a assez de ces enfantillages.<br />Il demande à Léa<br />de terminer son assiette <br />et de manger ses betteraves. <br />Si Léa mangeait moins de cochonneries <br />durant la matinée, <br />elle réussirait à finir son repas <br />et le déjeuner <br />se déroulerait plus tranquillement.<br />Le tonton de Léa est très énervé,<br />en tant que bon cuisinier,<br />lui adore manger, surtout les légumes<br />qui proviennent des fermes environnantes.<br />Il ne comprend pas que Léa<br />soit aussi capricieuse.<br /></span>,
  text7: <span>Tonton en a assez de ces <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>enfant</mark>illages.<br />Il demande à Léa<br />de terminer son assiette <br />et de manger ses betteraves. <br />Si Léa mangeait moins de cochonneries <br />durant la <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>matin</mark>ée, <br />elle réussirait à finir son repas <br />et le déjeuner <br />se déroulerait plus <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>tranquille</mark>ment.<br />Le tonton de Léa est très énervé,<br />en tant que bon <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>cuisin</mark>ier,<br />lui adore manger, surtout les légumes<br />qui pro<mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>viennent</mark> des fermes <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>environn</mark>antes.<br />Il ne comprend pas que Léa<br />soit aussi <mark style={{backgroundColor: 'yellow',paddingRight: '0px',paddingLeft: '0px'}}>capric</mark>ieuse.<br /></span>,
  text8: <span>Ma la domanda<br />non le migliorò l’umore.<br />Evi scosse cupa la testa<br />e io avrei voluto<br />non averle chiesto niente.<br />Come promesso, dopo ricreazione<br />la maestra portò in classe<br />la nuova compagna.<br />Ci fece avvicinare tutti alla cattedra<br />per riuscire a vederla meglio.<br />Mentre noi ce ne stavamo<br />attorno a lei, la bambina,<br />che si chiamava Lina,<br />fissava concentrata il pavimento.<br />La capivo bene.<br />A dire la verità non faceva pensare<br />né al calcio né alla Svezia.<br />Era piccola ed esile<br />e aveva i capelli lunghi e scuri.<br />A furia di fissare il pavimento<br />le si era formata una ruga<br />sulla fronte,<br />che la faceva assomigliare un po’<br />alla mia compagna di banco.<br />Io ed Evi ci guardammo.<br />Lei spinse il labbro inferiore<br />in avanti e fece spallucce.<br />La maestra<br />mise una mano sulla spalla<br />alla bambina nuova<br />ed ebbi l’impressione<br />che la ruga sulla sua fronte<br />si facesse ancora più profonda.<br />«Questa è Lina»<br />esclamò la maestra nel tono<br />più allegro possibile.<br />«È venuta qui da noi dalla Siria<br />assieme a suo padre<br />e non parla ancora molto bene<br />il tedesco.<br />Volete domandarle qualcosa?»<br /></span>
}

const consigne = <div>Tu peux lire le texte une première fois tout seul silencieusement.<br />Quand tu es prêt, appuie sur le micro rouge.<br />Tu dois lire le texte à voix haute.<br />Prends ton temps et pense à bien respecter les points.</div>

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioDetails: {
        url: null,
        blob: null,
        chunks: null,
        duration: {
          h: 0,
          m: 0,
          s: 0
        }
      },
      step: 1,
      text2Display: "",
    }
  }

  formRef = React.createRef();

  // AUDIO HANDLER
  handleAudioStop(data) {
    this.setState({ audioDetails: data, step: 3 });
  }

  handleAudioUpload(data) {
    axios.post("/api", data, {})
      .then(res => { // then print response status
        message.success('Données sauvegardées')
        console.log(res.statusText)
        this.handleAudioReset()
      }).catch(err => {
        message.error('Problème de sauvegarde des données sur le seveur. Merci de réessayer plus tard')
        console.log(err)
      })
  }

  handleAudioReset = () => {
    const resetaudio = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0
      }
    }

    this.setState({ audioDetails: resetaudio });
    console.log('AUDIO RESET')
  }

  handleReset = (evt) => {
    this.formRef.current.resetFields();
    this.setState({ text2Display: '' })
  }

  goStep = (nextstep) => {
    console.log("STEP " + nextstep)
    this.setState({ step: nextstep })
  }

  // FORM HANDLER
  onChange = (changedValues, allValues) => {
    if (changedValues.textValue) {
      this.setState({ text2Display: listText[changedValues.textValue] })
    }
  }

  handleSubmit = (values) => {
    // event.preventDefault();
    const file = this.state.audioDetails.blob
    const inputformdata = this.formRef.current.getFieldsValue()
    console.log(inputformdata)

    const data = new FormData()
    data.append('file', file)
    data.append('age', inputformdata.ageValue)
    data.append('class', inputformdata.classValue)
    data.append('genre', inputformdata.genreValue)
    data.append('scorefluence', inputformdata.scorefluenceValue)
    data.append('issues', inputformdata.issuesValue)
    data.append('fullread', inputformdata.fullreadValue)
    data.append('text', inputformdata.textValue)


    axios.get('https://geolocation-db.com/json/').then(res => {
      data.append('origin_IP', res.data.IPv4)
      data.append('origin_city', res.data.city)
      data.append('origin_country', res.data.country_name)
      data.append('origin_postal', res.data.postal)
      this.handleAudioUpload(data)
    }).catch(err => {
      console.log('ERROR geoloc')
      console.log(err)
      this.handleAudioUpload(data)
    })

    this.setState({ step: 4 })
  }

  reset = () => {
    this.handleReset()
    this.goStep(1)
  }


  render() {
    return (
      <Layout style={{ height: "100vh" }}>
        <Form ref={this.formRef} layout="horizontal" onValuesChange={this.onChange} >

          <Header className="header">
            <Row>
              <Col span={20}><h2>Fluence @ FROG</h2></Col>
              <Col span={4}><span className="logoheader"></span></Col>
            </Row>
          </Header>
          <Content>

            <div id='formpart1' className={this.state.step === 1 ? "" : "hideform"} >

              <Form.Item label="Age" name="ageValue" defaultValue='' >
                <InputNumber />
              </Form.Item>
              <Form.Item label="Genre" name="genreValue" defaultValue='' >
                <Radio.Group>
                  <Radio value="M">Garçon</Radio>
                  <Radio value="F">Fille</Radio>
                </Radio.Group>
              </Form.Item>
              <br />
              <Form.Item label="Score Fluence" name="scorefluenceValue" defaultValue='' >
                <InputNumber />
              </Form.Item>
              <Form.Item label="Commentaire" name="issuesValue" defaultValue='' >
                <Input />
              </Form.Item>
              <Form.Item label="Classe" name="classValue" defaultValue='' >
                <Input />
              </Form.Item>
              <Row className='commandes'>
                <Col span={12}><Button onClick={this.handleReset}>Effacer</Button></Col>
                <Col span={12}><Button type="primary" onClick={() => this.goStep(2)}>Choisir le texte</Button></Col>
              </Row>
            </div>

            {/* <div className='message'>{this.state.message}</div>  */}

            <div id='formpart2' className={this.state.step === 2 ? "" : "hideform"}>
              <Form.Item label={this.state.text2Display ? '' : 'Sélectionne un texte'} name="textValue" placeholder="Sélectionner un texte">
                <Select>
                  <Option value="text1">Texte 1 - (39 mots) Je lis avec Mona et ses amis, Magnard</Option>
                  <Option value="text2">Texte 2 - (53 mots) Gabriel et Gabriel, Livre de poche jeunesse</Option>
                  <Option value="text3">Texte 3 - (57 mots) Hercule Navet enquête, Belin</Option>
                  <Option value="text4">Texte 4 - Les cousins Karlsson (Rhésé) </Option>
                  <Option value="text5">Texte 5 - Les cousins Karlsson</Option>
                  <Option value="text6">Texte 6 - Betteraves</Option>
                  <Option value="text7">Texte 7 - Betteraves et Radis</Option>
                  <Option value="text8">Texte 8 - La banda della zuppa di piselli</Option>
                </Select>
              </Form.Item>
              <div className={this.state.text2Display ? 'text2display' : 'consigne'} >{this.state.text2Display ? this.state.text2Display : consigne}</div>
              <Button onClick={() => this.goStep(1)}>Retour</Button>
            </div>

          </Content>
          <Footer>
            <div id='formpart2bis' className={this.state.step === 2 && this.state.text2Display ? "" : "hideform"}>

              <Recorder id="recorder" key="1"
                record={true}
                title
                audioURL={this.state.audioDetails.url}
                showUIAudio={false}
                handleAudioStop={data => this.handleAudioStop(data)}
                handleAudioUpload={data => this.handleAudioUpload(data)}
                handleReset={() => this.handleReset()}
                // mimeTypeToUseWhenRecording={`audio/webm`}
                helptext
                disableUploadUI={true}
                hideHeader={true}
              />
            </div>
            <div id='formpart3' className={this.state.step === 3 ? "" : "hideform"}>
              <Form.Item label="Texte lu en entier" name="fullreadValue" valuePropName="checked">
                <Switch />
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={this.handleSubmit}>Valider</Button>
                <Button onClick={() => this.goStep(2)}>Annuler</Button>
              </Form.Item>
            </div>
            <div id='formpart3' className={this.state.step === 4 ? "" : "hideform"}>
              <Form.Item>
                <Row className='commandes'>
                  <Col span={12}><Button onClick={() => this.goStep(2)} danger>Nouveau texte</Button></Col>
                  <Col span={12}><Button onClick={this.reset} type="primary" danger>Nouvel élève</Button></Col>
                </Row>
              </Form.Item>
            </div>
          </Footer>
        </Form>

      </Layout>

    )
  }
}

export default App
